export const financeRefundRoles = ['general_manager']
export const refundOverviewRoles = ['general_manager', 'finance_manager', 'sales_supervisor', 'accountant_manager', 'accountant_supervisor']
export const responsibleRoles = ['sales_manager', 'sales_supervisor', 'general_manager']
export const refundRoles = [...refundOverviewRoles, 'sales_manager']
export const snackbarOperationsRoles = ['general_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'operations_manager', 'operations_supervisor']

export const hasSafariRole = (groups, roles) => (groups || []).some(group => roles.includes(group.code))
export const snackbarHome = groups => hasSafariRole(groups, snackbarOperationsRoles) ? 'safari-snack-bar' : 'safari-snackbar-refunds'
export const refundReturnPath = value => typeof value === 'string' && /^\/(?:safari\/snack-bar\/refunds|finance\/refunds(?:\/completed|\/all)?)\/?(?:\?(?:refund|payout)=\d+)?$/.test(value) ? value : null

export const normalizeFinanceRefund = data => ({
  ...data,
  group_id: data.source && data.source.group_id,
  group_name: data.reference,
  snackbar: data.source && data.source.snackbar,
  snackbar_preparation: (data.source && data.source.snackbar_preparation) || {}
})
